// @ts-nocheck
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  FormControl,
  Grid,
  TextField,
  MenuItem,
  Select,
  Switch,
  Typography,
  Input,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import { useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { UploadMedia } from "../../utils/uploadMedia";
import countries from "../../components/Json/country.json";
import { errorToast, successToast } from "../../helpers/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { useFormik } from "formik";
import { CommonBody } from "../../types/General";
import Loader from "../../helpers/constants/Loader";
import { error } from "console";
import { isNumber, isString, isValidInput } from "../../utils/validation";
import {
  useAddProductMutation,
  useLazyGetProductByIdQuery,
  useUpdateProductMutation,
} from "../../services/products";
import {
  useLazyAllCategoryQuery,
  useLazyAllSubcategoriesQuery,
} from "../../services/main";
import { errorMonitor } from "events";
import useTranslation from "../../hooks/Translation";

const AddProduct = () => {
  const { id } = useParams();
  const t = useTranslation();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [profile_picture, setProfilePicture] = useState("");
  const navigate = useNavigate();
  const [addProduct] = useAddProductMutation();
  const [getSubCategory] = useLazyAllSubcategoriesQuery();
  const [productById] = useLazyGetProductByIdQuery();
  const [updateProduct] = useUpdateProductMutation();
  const [getCategory] = useLazyAllCategoryQuery();
  const [myImages, setMyImages] = useState<any>([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedPlace, setSelectedPlace] = useState("");
  const [error, setError] = useState(false);
  const [productData, setProductData] = useState<any>("");
  const [bulkPricing, setBulkPricing] = useState<any>([]);
  const [selectedCountry, setSelectedCountry] = useState("");

  const handleAddRow = () => {
    if (bulkPricing.length > 0) {
      const lastRow = bulkPricing[bulkPricing.length - 1];
      if (!lastRow.minQty || !lastRow.maxQty || !lastRow.price) {
        errorToast("Please fill in all fields before adding a new row.");
        return;
      }
    }

    setBulkPricing([...bulkPricing, { minQty: "", maxQty: "", price: "" }]);
  };

  const handleRemoveRow = (index: any) => {
    setBulkPricing(bulkPricing.filter((_: any, i: any) => i !== index));
  };

  const handleBulkChange = (index: number, field: string, value: string) => {
    const updatedBulkPricing = [...bulkPricing];
    updatedBulkPricing[index] = {
      ...updatedBulkPricing[index], // Spread existing object
      [field]: value, // Update the specific field
    };
    setBulkPricing((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const [isPerUnit, setIsPerUnit] = useState(false);

  const handleToggle = () => {
    setIsPerUnit(!isPerUnit);
  };

  const handlePricingChange = (event: any) => {
    setSelectedCategory(event.target.value);
  };

  const handleSubCategoryChange = (event: any) => {
    setSelectedSubCategory(event.target.value);
  };

  const handleUnitChange = (event: any) => {
    setSelectedUnit(event.target.value);
  };

  const handlePlaceChange = (event: any) => {
    setSelectedPlace(event.target.value);
  };

  const handleCrossClick = async (e: any, i: any) => {
    e.stopPropagation();
    if (myImages.includes(i)) {
      let arr = [];
      arr = myImages.filter((name: any) => name !== i);
      setMyImages(arr);
    }
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const invalidFiles = Array.from(files).filter(
        (file: any) => !allowedTypes.includes(file.type)
      );
      if (invalidFiles.length > 0) {
        errorToast("Invalid image please upload again");
        return;
      }
      if (myImages.length + files.length > 10) {
        errorToast(t.error.max10Image);
        return;
      }
      const uploadedImages = Array.from(files).map((file: any) => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setMyImages((prevImages: any) => [...prevImages, ...uploadedImages]);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      product_image: "",
      product_name_ar: productData?.product_name_ar || "",
      product_name_en: productData?.product_name_en || "",
      product_name_rs: productData?.product_name_rs || "",
      price_per_unit: productData?.price_per_unit || "",
      price_per_unit_package: productData?.price_per_unit || "",
      total_quantity: productData?.total_quantity || "",
      quantity_per_unit_package: productData?.quantity_per_unit || "",
      grade_ar: productData?.grade_ar || "",
      grade_en: productData?.grade_en || "",
      grade_rs: productData?.grade_rs || "",
      model_no_en: productData?.model_no_en || "",
      model_no_ar: productData?.model_no_ar || "",
      model_no_rs: productData?.model_no_rs || "",
      shell_life_en: productData?.shell_life_en || "",
      shell_life_ar: productData?.shell_life_ar || "",
      shell_life_rs: productData?.shell_life_rs || "",
      style_en: productData?.style_en || "",
      style_ar: productData?.style_ar || "",
      style_rs: productData?.style_rs || "",
      place_of_origin_en: [""],
      place_of_origin_ar: [""],
      place_of_origin_rs: [""],
      product_type_en: productData?.product_type_en || "",
      product_type_ar: productData?.product_type_ar || "",
      product_type_rs: productData?.product_type_rs || "",
      product_desc_en: productData?.product_desc_en || "",
      product_desc_ar: productData?.product_desc_ar || "",
      product_desc_rs: productData?.product_desc_rs || "",
      // delivery_time: productData?.delivery_time || "",
      // shipping: "",
      bulk_pricing: [],
      min_quantity: productData?.min_quantity || "",
      min_quantity_package: productData?.min_quantity || "",
    },
    validationSchema: Yup.object({
      product_name_en: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40)
        .min(2, t.error.minValidation),
      product_name_ar: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40)
        .min(2, t.error.minValidation),
      product_name_rs: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40)
        .min(2, t.error.minValidation),
      price_per_unit: isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
      price_per_unit_package: !isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
      total_quantity: Yup.string().required(t.error.required),

      quantity_per_unit_package: !isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),

      grade_ar: Yup.string().required(t.error.required).max(40, t.error.max40),

      grade_en: Yup.string().required(t.error.required).max(40, t.error.max40),

      grade_rs: Yup.string().required(t.error.required).max(40, t.error.max40),

      model_no_en: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      model_no_ar: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      model_no_rs: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      shell_life_en: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      shell_life_ar: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      shell_life_rs: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      style_en: Yup.string().required(t.error.required).max(40, t.error.max40),

      style_ar: Yup.string().required(t.error.required).max(40, t.error.max40),

      style_rs: Yup.string().required(t.error.required).max(40, t.error.max40),

      product_type_en: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      product_type_ar: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      product_type_rs: Yup.string()
        .required(t.error.required)
        .max(40, t.error.max40),

      product_desc_en: Yup.string()
        .required(t.error.required)
        .max(250, t.error.max250),

      product_desc_ar: Yup.string()
        .required(t.error.required)
        .max(250, t.error.max250),

      product_desc_rs: Yup.string()
        .required(t.error.required)
        .max(250, t.error.max250),

      min_quantity: isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
      min_quantity_package: !isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      // if (!profilePicture) {
      //   warnToast("Please upload an image");
      //   return;
      // }
      let images: any[] = [];
      if (myImages?.length) {
        await Promise.all(
          myImages.map(async (item: any) => {
            if (item?.id) {
              // If item already has an ID, push it directly
              images?.push(item.id);
            } else {
              // Otherwise, upload the media
              const res = await UploadMedia(item?.file);
              if (res?.status === 200 && res?.data?.length) {
                images?.push(res.data[0]?.id);
              }
            }
          })
        );
      }
      if (!id && !images?.length) {
        errorToast(t.error.pleaseUploadImage);
        return;
      }
      if (!selectedCategory) {
        return;
      }
      if (!selectedSubCategory) {
        return;
      }

      console.log(images);

      for (let it of bulkPricing) {
        if (it?.minQty === "") {
          errorToast(t.error.fillMinimum);
          return;
        } else if (it?.maxQty === "") {
          errorToast(t.error.fillMaximum);
          return;
        } else if (it?.price === "") {
          errorToast(t.error.fillPrice);
          return;
        }
      }

      const body = {
        sub_category: selectedSubCategory,
        product_image: images,
        product_name_ar: values.product_name_ar || "",
        product_name_en: values.product_name_en || "",
        product_name_rs: values.product_name_rs || "",
        price_per_unit: isPerUnit
          ? Number(values.price_per_unit_package)
          : Number(values.price_per_unit),
        total_quantity: values.total_quantity || "100",
        quantity_per_unit: values.quantity_per_unit_package,
        grade_ar: values.grade_ar || "",
        grade_en: values.grade_en || "",
        grade_rs: values.grade_rs || "",
        model_no_en: values.model_no_en || "",
        model_no_ar: values.model_no_ar || "",
        model_no_rs: values.model_no_rs || "",
        shell_life_en: values.shell_life_en || "",
        shell_life_ar: values.shell_life_ar || "",
        shell_life_rs: values.shell_life_rs || "",
        style_en: values.style_en || "",
        style_ar: values.style_ar || "",
        style_rs: values?.style_rs || "",
        place_of_origin_en: [selectedPlace],
        place_of_origin_ar: [selectedPlace],
        place_of_origin_rs: [selectedPlace],
        product_type_en: values.product_type_en || "",
        product_type_ar: values.product_type_ar || "",
        product_type_rs: values.product_type_rs || "",
        product_desc_en: values.product_desc_en || "Test",
        product_desc_ar: values.product_desc_ar || "Test",
        product_desc_rs: values.product_desc_rs || "Test",
        // delivery_time: values.delivery_time || "",
        // shipping: values.shipping || "",
        bulk_pricing: bulkPricing,
        product_status: 3,
        product_type: isPerUnit ? 1 : 2,
        category: selectedCategory,
        product_quantity_type: Number(selectedUnit) || 1,
        min_quantity: isPerUnit
          ? Number(values.min_quantity_package)
          : Number(values.min_quantity),
      };

      console.log(body, "body-------");

      if (!id)
        try {
          const encryptedBody = generateEncryptedKeyBody(body) as any;
          const response = await addProduct(encryptedBody).unwrap();
          if (response.status === 200) {
            successToast(response.data.message || t.main.productAdded);
            navigate("/manage-products", { state: 1 });
          } else {
            errorToast(response.data.message || "");
          }
        } catch (e) {
          errorToast(e?.data?.message);
        }
      else {
        try {
          const encryptedBody = generateEncryptedKeyBody(body) as any;
          const response = await updateProduct({
            id: id,
            body: encryptedBody,
          }).unwrap();
          if (response.status === 200) {
            successToast(t.main.productUpdated);
            navigate("/manage-products");
          } else {
            errorToast(response?.message || "");
          }
        } catch (e) {
          errorToast(e?.message || "");
        }
      }
    },
  });

  const getProductDetails = async () => {
    try {
      const res = await productById({ id }).unwrap();
      if (res?.status === 200) {
        setProductData(res?.data);
        setMyImages(res?.data?.product_image);
        setIsPerUnit(res?.data?.product_type === 1 ? true : false);
        setSelectedUnit(String(res?.data?.product_quantity_type));
        setSelectedSubCategory(res?.data?.sub_category?.id);
        setSelectedCategory(res?.data?.sub_category?.category?.id);
        setSelectedPlace(res?.data?.place_of_origin_en[0]);
        setBulkPricing(res?.data?.bulk_pricing);
        setSelectedCountry(res?.data?.place_of_origin_en[0]);
      }
    } catch (error) {
      console.log(error, "errror");
      // errorToast(error?.data?.message || "");
    }
  };

  const getCategoryDetail = async () => {
    try {
      const res = await getCategory({}).unwrap();
      if (res?.status === 200) {
        setCategoryData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const getSubCategoryDetail = async () => {
    try {
      const res = await getSubCategory({ id: selectedCategory }).unwrap();
      if (res?.status === 200) {
        setSubCategoryData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      getSubCategoryDetail();
    }
  }, [selectedCategory]);

  useEffect(() => {
    getCategoryDetail();
  }, []);

  useEffect(() => {
    if (id) {
      getProductDetails();
    }
  }, []);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">
            {id ? t.main.editProduct : t.main.addProduct}
          </h1>
          <Loader isLoad={isLoading} />
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-products", { state: state });
            }}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 0, pb: 0 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid container spacing={2} className="form_control">
                    <Grid
                      item
                      lg={3}
                      md={3}
                      sm={6}
                      xs={12}
                      className="upload_document v2 w_50"
                    >
                      <Typography variant="h6" mb={1}>
                        {t.main.images}
                      </Typography>
                      {myImages?.length >= 10 ? null : (
                        <Box className="upload_image_bnr">
                          <label htmlFor="icon-button-file-vdo">
                            <Input
                              sx={{ display: "none" }}
                              id="icon-button-file-vdo"
                              type="file"
                              inputProps={{
                                accept: ".png, .jpg, .jpeg, .svg",
                                multiple: true,
                              }}
                              onChange={handleFileUpload}
                            />
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <AddIcon />
                            </Button>
                          </label>
                        </Box>
                      )}
                    </Grid>
                    {myImages?.length ? (
                      <>
                        {myImages?.map((item: any, i: any) => {
                          return (
                            <Grid
                              item
                              lg={3}
                              md={3}
                              sm={6}
                              xs={12}
                              className="upload_document w_50"
                              key={i}
                              style={{ cursor: "pointer", marginTop: "36px" }}
                              // onClick={() => {
                              //   setOpen_gallery(true);
                              //   setPreview(item?.url);
                              // }}
                            >
                              <div className="inner">
                                <div className="cross_icn">
                                  <CloseIcon
                                    onClick={(e) => handleCrossClick(e, item)}
                                  />
                                </div>

                                <figure>
                                  <img
                                    src={item?.url || item?.media_url}
                                    alt="upload"
                                  />
                                </figure>
                              </div>
                            </Grid>
                          );
                        })}
                      </>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.productNameEn}
                  </Typography>

                  <TextField
                    type="text"
                    placeholder={t.main.productNameEn}
                    id="product_name_en"
                    name="product_name_en"
                    variant="outlined"
                    fullWidth
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (val.target.value) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_name_en}
                    helperText={
                      formik.touched.product_name_en &&
                      formik.errors.product_name_en
                    }
                    error={
                      formik.touched.product_name_en &&
                      formik.errors.product_name_en
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.productNameAr}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.productNameAr}
                    fullWidth
                    variant="outlined"
                    id="product_name_ar"
                    name="product_name_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (val.target.value) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_name_ar}
                    helperText={
                      formik.touched.product_name_ar &&
                      formik.errors.product_name_ar
                    }
                    error={
                      formik.touched.product_name_ar &&
                      formik.errors.product_name_ar
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.productNameRu}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.productNameRu}
                    variant="outlined"
                    fullWidth
                    id="product_name_rs"
                    name="product_name_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (val.target.value) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_name_rs}
                    helperText={
                      formik.touched.product_name_rs &&
                      formik.errors.product_name_rs
                    }
                    error={
                      formik.touched.product_name_rs &&
                      formik.errors.product_name_rs
                    }
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.category}
                  </Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={priceType}
                      value={selectedCategory}
                      TextFieldProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handlePricingChange}
                      error={error && !selectedCategory}
                    >
                      <MenuItem value="" disabled>
                        {t.main.selectCategory}
                      </MenuItem>
                      {categoryData?.length
                        ? categoryData?.map((item) => (
                            <MenuItem key={item?.id} value={item?.id}>
                              {item?.category_name || ""}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                    {error && !selectedCategory ? (
                      <Typography className="err_msg">
                        {t.error.required}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.subCategory}
                  </Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={priceType}
                      value={selectedSubCategory}
                      TextFieldProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handleSubCategoryChange}
                      error={error && !selectedSubCategory}
                    >
                      <MenuItem value="" disabled>
                        {t.main.selectSubCategory}
                      </MenuItem>
                      {subCategoryData?.length
                        ? subCategoryData?.map((item: any) => (
                            <MenuItem key={item?.id} value={item?.id}>
                              {item?.sub_category_name || ""}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                    {error && !selectedSubCategory ? (
                      <Typography className="err_msg">
                        {t.error.required}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.gradeEn}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.gradeEn}
                    variant="outlined"
                    fullWidth
                    id="grade_en"
                    name="grade_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.grade_en}
                    helperText={
                      formik.touched.grade_en && formik.errors.grade_en
                    }
                    error={formik.touched.grade_en && formik.errors.grade_en}
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.gradeAr}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.gradeAr}
                    variant="outlined"
                    fullWidth
                    id="grade_ar"
                    name="grade_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.grade_ar}
                    helperText={
                      formik.touched.grade_ar && formik.errors.grade_ar
                    }
                    error={formik.touched.grade_ar && formik.errors.grade_ar}
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.gradeRu}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.gradeRu}
                    variant="outlined"
                    fullWidth
                    id="grade_rs"
                    name="grade_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.grade_rs}
                    helperText={
                      formik.touched.grade_rs && formik.errors.grade_rs
                    }
                    error={formik.touched.grade_rs && formik.errors.grade_rs}
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.modelEn}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.modelEn}
                    variant="outlined"
                    fullWidth
                    id="model_no_en"
                    name="model_no_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isValidInput(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.model_no_en}
                    helperText={
                      formik.touched.model_no_en && formik.errors.model_no_en
                    }
                    error={
                      formik.touched.model_no_en && formik.errors.model_no_en
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.modelAr}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.modelAr}
                    variant="outlined"
                    fullWidth
                    id="model_no_ar"
                    name="model_no_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isValidInput(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.model_no_ar}
                    helperText={
                      formik.touched.model_no_ar && formik.errors.model_no_ar
                    }
                    error={
                      formik.touched.model_no_ar && formik.errors.model_no_ar
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.modelRu}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.modelRu}
                    variant="outlined"
                    fullWidth
                    id="model_no_rs"
                    name="model_no_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isValidInput(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.model_no_rs}
                    helperText={
                      formik.touched.model_no_rs && formik.errors.model_no_rs
                    }
                    error={
                      formik.touched.model_no_rs && formik.errors.model_no_rs
                    }
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.shelfEn}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.shelfEn}
                    variant="outlined"
                    fullWidth
                    id="shell_life_en"
                    name="shell_life_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.shell_life_en}
                    helperText={
                      formik.touched.shell_life_en &&
                      formik.errors.shell_life_en
                    }
                    error={
                      formik.touched.shell_life_en &&
                      formik.errors.shell_life_en
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.shelfAr}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.shelfAr}
                    variant="outlined"
                    fullWidth
                    id="shell_life_ar"
                    name="shell_life_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.shell_life_ar}
                    helperText={
                      formik.touched.shell_life_ar &&
                      formik.errors.shell_life_ar
                    }
                    error={
                      formik.touched.shell_life_ar &&
                      formik.errors.shell_life_ar
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.shelfRu}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.shelfRu}
                    variant="outlined"
                    fullWidth
                    id="shell_life_rs"
                    name="shell_life_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.shell_life_rs}
                    helperText={
                      formik.touched.shell_life_rs &&
                      formik.errors.shell_life_rs
                    }
                    error={
                      formik.touched.shell_life_rs &&
                      formik.errors.shell_life_rs
                    }
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.styleEn}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.styleEn}
                    variant="outlined"
                    fullWidth
                    id="style_en"
                    name="style_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.style_en}
                    helperText={
                      formik.touched.style_en && formik.errors.style_en
                    }
                    error={formik.touched.style_en && formik.errors.style_en}
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.styleAr}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.styleAr}
                    variant="outlined"
                    fullWidth
                    id="style_ar"
                    name="style_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.style_ar}
                    helperText={
                      formik.touched.style_ar && formik.errors.style_ar
                    }
                    error={formik.touched.style_ar && formik.errors.style_ar}
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.styleRu}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.styleRu}
                    variant="outlined"
                    fullWidth
                    id="style_rs"
                    name="style_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.style_rs}
                    helperText={
                      formik.touched.style_rs && formik.errors.style_rs
                    }
                    error={formik.touched.style_rs && formik.errors.style_rs}
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.productTypeEn}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.productTypeEn}
                    variant="outlined"
                    fullWidth
                    id="product_type_en"
                    name="product_type_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_type_en}
                    helperText={
                      formik.touched.product_type_en &&
                      formik.errors.product_type_en
                    }
                    error={
                      formik.touched.product_type_en &&
                      formik.errors.product_type_en
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.producTypeAr}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.producTypeAr}
                    variant="outlined"
                    fullWidth
                    id="product_type_ar"
                    name="product_type_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_type_ar}
                    helperText={
                      formik.touched.product_type_ar &&
                      formik.errors.product_type_ar
                    }
                    error={
                      formik.touched.product_type_ar &&
                      formik.errors.product_type_ar
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.productTypeRu}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.productTypeRu}
                    variant="outlined"
                    fullWidth
                    id="product_type_rs"
                    name="product_type_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_type_rs}
                    helperText={
                      formik.touched.product_type_rs &&
                      formik.errors.product_type_rs
                    }
                    error={
                      formik.touched.product_type_rs &&
                      formik.errors.product_type_rs
                    }
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.placeOfOrigin}
                  </Typography>
                  <FormControl fullWidth>
                    <Autocomplete
                      // multiple
                      options={countries || []}
                      getOptionLabel={(option) => option?.name || "No Name"}
                      value={
                        countries?.find(
                          (item: any) => item?.name === selectedCountry
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSelectedCountry(newValue?.name || "");
                      }}
                      ListboxProps={{
                        style: { maxHeight: "200px" }, // Adjust dropdown height here
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select"
                          error={error && !selectedCountry}
                        />
                      )}
                    />
                    {error && !selectedCountry ? (
                      <h6 className="err_msg">{t.error.required}</h6>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.stock}
                  </Typography>
                  <TextField
                    type="text"
                    placeholder={t.main.stock}
                    variant="outlined"
                    fullWidth
                    id="total_quantity"
                    name="total_quantity"
                    inputProps={{ maxLength: 10 }}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.total_quantity}
                    helperText={
                      formik.touched.total_quantity &&
                      formik.errors.total_quantity
                    }
                    error={
                      formik.touched.total_quantity &&
                      formik.errors.total_quantity
                    }
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.priceUnit}
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      displayEmpty
                      value={selectedUnit}
                      onChange={handleUnitChange}
                      error={error && !selectedUnit}
                    >
                      <MenuItem value="" disabled>
                        {t.main.select}
                      </MenuItem>

                      <MenuItem value={"1"}>KG</MenuItem>
                      <MenuItem value={"2"}>Liter</MenuItem>
                    </Select>
                    {error && !selectedUnit ? (
                      <Typography className="err_msg">
                        {t.error.required}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  {/* Other fields */}

                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ paddingBottom: "5px" }}
                  >
                    <Switch checked={isPerUnit} onChange={handleToggle} />
                    <Typography variant="subtitle2">
                      {t.main.makeAsPackage}
                    </Typography>
                  </Box>

                  {/* Conditionally render the fields */}
                  {isPerUnit ? (
                    <Grid container spacing={2}>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {t.main.quantityPerUnit}
                        </Typography>
                        <TextField
                          type="text"
                          placeholder={t.main.quantityPerUnit}
                          variant="outlined"
                          fullWidth
                          inputProps={{ maxLength: 5 }}
                          id="quantity_per_unit_package"
                          name="quantity_per_unit_package"
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isNumber(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.quantity_per_unit_package}
                          helperText={
                            formik.touched.quantity_per_unit_package &&
                            formik.errors.quantity_per_unit_package
                          }
                          error={
                            formik.touched.quantity_per_unit_package &&
                            formik.errors.quantity_per_unit_package
                          }
                        />
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {t.main.pricePerUnit}
                        </Typography>
                        <TextField
                          type="text"
                          placeholder={t.main.pricePerUnit}
                          variant="outlined"
                          fullWidth
                          id="price_per_unit_package"
                          name="price_per_unit_package"
                          inputProps={{ maxLength: 10 }}
                          onChange={(val) => {
                            const value = val.target.value;
                            if (value === " " || value === ".") return;

                            // Regex to allow only numbers with up to two decimal places
                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.price_per_unit_package}
                          helperText={
                            formik.touched.price_per_unit_package &&
                            formik.errors.price_per_unit_package
                          }
                          error={
                            formik.touched.price_per_unit_package &&
                            formik.errors.price_per_unit_package
                          }
                          endAdornment={
                            <InputAdornment position="end">kg</InputAdornment>
                          }
                        />
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {t.main.minPerchaseQty}
                        </Typography>
                        <TextField
                          type="text"
                          placeholder={t.main.minPerchaseQty}
                          variant="outlined"
                          fullWidth
                          id="min_quantity_package"
                          name="min_quantity_package"
                          inputProps={{ maxLength: 5 }}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isNumber(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.min_quantity_package}
                          helperText={
                            formik.touched.min_quantity_package &&
                            formik.errors.min_quantity_package
                          }
                          error={
                            formik.touched.min_quantity_package &&
                            formik.errors.min_quantity_package
                          }
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {selectedUnit === "1"
                            ? "Price per kg"
                            : "Price per Liter"}
                        </Typography>
                        <TextField
                          type="text"
                          placeholder={
                            selectedUnit === "1"
                              ? t.main.pricePerKg
                              : t.main.pricePerLiter
                          }
                          variant="outlined"
                          fullWidth
                          id="price_per_unit"
                          name="price_per_unit"
                          inputProps={{ maxLength: 10 }}
                          onChange={(val) => {
                            const value = val.target.value;
                            if (value === " " || value === ".") return;

                            // Regex to allow only numbers with up to two decimal places
                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.price_per_unit}
                          helperText={
                            formik.touched.price_per_unit &&
                            formik.errors.price_per_unit
                          }
                          error={
                            formik.touched.price_per_unit &&
                            formik.errors.price_per_unit
                          }
                        />
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {selectedUnit === "1"
                            ? t.main.minQtyKg
                            : t.main.minQtyLiter}
                        </Typography>
                        <TextField
                          type="text"
                          placeholder="Min Purchase Quantity"
                          variant="outlined"
                          fullWidth
                          inputProps={{ maxLength: 5 }}
                          id="min_quantity"
                          name="min_quantity"
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isNumber(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.min_quantity}
                          helperText={
                            formik.touched.min_quantity &&
                            formik.errors.min_quantity
                          }
                          error={
                            formik.touched.min_quantity &&
                            formik.errors.min_quantity
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.descEng}
                  </Typography>
                  <TextField
                    type={"text"}
                    placeholder={t.main.descEng}
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={4}
                    id="product_desc_en"
                    name="product_desc_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_desc_en}
                    helperText={
                      formik.touched.product_desc_en &&
                      formik.errors.product_desc_en
                    }
                    error={
                      formik.touched.product_desc_en &&
                      formik.errors.product_desc_en
                    }
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.descAr}
                  </Typography>
                  <TextField
                    type={"text"}
                    placeholder={t.main.descAr}
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={4}
                    id="product_desc_ar"
                    name="product_desc_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_desc_ar}
                    helperText={
                      formik.touched.product_desc_ar &&
                      formik.errors.product_desc_ar
                    }
                    error={
                      formik.touched.product_desc_ar &&
                      formik.errors.product_desc_ar
                    }
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle2" className="custom_label">
                    {t.main.descRu}
                  </Typography>
                  <TextField
                    type={"text"}
                    placeholder={t.main.descRu}
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={4}
                    id="product_desc_rs"
                    name="product_desc_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_desc_rs}
                    helperText={
                      formik.touched.product_desc_rs &&
                      formik.errors.product_desc_rs
                    }
                    error={
                      formik.touched.product_desc_rs &&
                      Boolean(formik.errors.product_desc_rs)
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6" mb={1}>
                    {t.main.bulkPricing}
                  </Typography>
                  <Box className="bulk_pricing_table">
                    {bulkPricing?.map((row, index) => (
                      <Grid container spacing={2} key={index} mb={1}>
                        <Grid item xs={3}>
                          <Typography
                            variant="subtitle2"
                            className="custom_label"
                          >
                            {t.main.minQty}
                          </Typography>
                          <TextField
                            type="text"
                            placeholder={t.main.minQty}
                            variant="outlined"
                            fullWidth
                            value={row?.minQty}
                            onChange={(e) =>
                              handleBulkChange(index, "minQty", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Typography
                            variant="subtitle2"
                            className="custom_label"
                          >
                            {t.main.maxQty}
                          </Typography>
                          <TextField
                            type="text"
                            placeholder={t.main.maxQty}
                            variant="outlined"
                            fullWidth
                            value={row?.maxQty}
                            onChange={(e) =>
                              handleBulkChange(index, "maxQty", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Typography
                            variant="subtitle2"
                            className="custom_label"
                          >
                            {t.main.price}
                          </Typography>
                          <TextField
                            type="text"
                            placeholder={t.main.price}
                            variant="outlined"
                            fullWidth
                            value={row?.price}
                            onChange={(val) => {
                              const value = val.target.value;
                              if (value === " " || value === ".") return;
                              // Regex to allow only numbers with up to two decimal places
                              if (/^\d*\.?\d{0,2}$/.test(value)) {
                                handleBulkChange(index, "price", value);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={3} mt={3}>
                          <Button
                            onClick={() => handleRemoveRow(index)}
                            variant="outlined"
                            className="btn btn_primary"
                          >
                            {t.main.remove}
                          </Button>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>

                  <Button
                    onClick={handleAddRow}
                    sx={{ marginTop: 2 }}
                    className="btn btn_primary"
                  >
                    {t.main.addBulk}
                  </Button>
                </Grid>
              </Grid>
              <div className="form_btn">
                <Button
                  size="large"
                  type="submit"
                  className="btn btn_primary"
                  onClick={() => {
                    setError(true);
                  }}
                >
                  {id ? t.main.update : t.main.add}
                </Button>
              </div>
            </CardContent>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default AddProduct;
